
import { LookupDriverFull } from '@/models/main';
import { SchedulerShift } from '@/models/scheduler';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class DriversLookup extends Vue {
  @Prop(Array) public drivers!: LookupDriverFull[];
  @Prop(Array) public readonly driversChosen!: number[];
  @Prop(Object) private readonly shift: SchedulerShift;
  @Prop(Boolean) public readonly disabled: boolean;
  @Prop(Boolean) private readonly extented: boolean;

  public selectedDriverDefault = {
    id: -1,
    code: -1,
    full_name: '',
    mobile_phone: '',
  };
  public selectedDriver = { ...this.selectedDriverDefault };
  public driversFiltred: LookupDriverFull[] = [];

  public clear() {
    this.selectedDriver = { ...this.selectedDriverDefault };
  }

  public filterDrivers() {
    this.driversFiltred = this.drivers.filter(driver => {
      return !this.driversChosen.includes(driver.code) || this.selectedDriver.code === driver.code;
    });
  }

  public handleInput(evt) {
    if (!evt) {
      return;
    }
    const chosenString = this.selectedDriver.full_name.slice(0, evt.length);
    if (this.selectedDriver.id >= 0 && evt !== chosenString) {
      this.clear();
      return evt;
    }
  }

  public change(item) {
    if (item) {
      this.selectedDriver = item;
      this.shift.driver = item.code;
      this.shift.driver_fullname = item.full_name;
    } else {
      this.shift.driver = null;
    }
    this.$emit('change', this.shift);
  }

  @Watch('shift', { immediate: true, deep: true })
  private watchToShift() {
    const find = this.drivers.find(x => x.code === this.shift.driver);
    if (find) {
      this.selectedDriver = find;
    } else {
      this.selectedDriver = {
        id: -1,
        code: -1,
        full_name: '',
        mobile_phone: '',
      };
    }
  }

  @Watch('driversChosen', { deep: true })
  private watchToDrivers() {
    this.filterDrivers();
  }

  private mounted() {
    this.filterDrivers();
  }
}
